import React from 'react';
import './Map.css';

function Map() {
    return (
        <div className="map">
            Map
        </div>
    )
}

export default Map